import React, { useState } from "react";
import { FaUser } from "react-icons/fa";
import { PiBriefcaseDuotone } from "react-icons/pi";
import { FaLocationDot } from "react-icons/fa6";
import { FaFileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { FaFilePdf } from "react-icons/fa";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ResumeBuilder = () => {
  const [step, setStep] = useState(1); // STEP STATE
  const [formData, setFormData] = useState({
    fullName: "Diya Agarwal",
    title: "Retail Sales Professional",
    email: "d.agarwal@sample.in",
    phone: "+91 11 5555 3345",
    address: "New Delhi, India 110034",
    summary:
      "Customer-focused Retail Sales professional with solid understanding of retail dynamics, marketing and customer service. Offering 5 years of experience providing quality product recommendations and solutions to meet customer needs and exceed expectations. Demonstrated record of exceeding revenue targets by leveraging communication skills and sales expertise.",
    experience: ["Retail Sales Professional at ABC Retailers (2019 - 2024)"],
    education: [
      "B.Sc. in Commerce, Delhi University, 2019",
      "12th, CBSE Board, 2016",
      "10th, CBSE Board, 2014",
    ],
    skills: ["Customer Service", "Sales", "Marketing"],
    profilePic: "https://randomuser.me/api/portraits/women/44.jpg",
    company: "Capgemini",
    position: "Soft Engineer",
    duration: "February 2017 - Current",
    jobDescription: [
      "Increased monthly sales by 10% through upselling and cross-selling.",
      "Prevented store losses through attention to detail and integrity.",
      "Processed payments accurately to meet financial targets.",
    ],
    ugDegree: "B.Com (Hons)",
    ugCGPA: "8.2",
    ugYear: "2023",
    twelveBoard: "CBSE",
    twelvePercent: "91%",
    twelveYear: "2020",
    tenBoard: "CBSE",
    tenPercent: "93%",
    tenYear: "2018",
    languages: ["Hindi:native", "English:proficient", "Bengali:intermediate"],
    templateColor: "orange",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;

    if (id === "languages") {
      // Split the comma-separated input and trim each item
      const languagesArray = value.split(",").map((item) => item.trim());
      setFormData({ ...formData, languages: languagesArray });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, profilePic: URL.createObjectURL(file) });
    }
  };
  const getTemplateColor = () => {
    switch (formData.templateColor) {
      case "blue":
        return "#007bff";
      case "brown":
        return "#8B4513";
      case "orange":
        return "rgb(242, 110, 80)";
      default:
        return "rgb(242, 110, 80)";
    }
  };
  const handleSavePDF = async () => {
    const element = document.getElementById("resumeContent");
    if (!element) return;
  
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
    });
  
    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const pdf = new jsPDF("p", "mm", "a4");
  
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
  
    const imgProps = pdf.getImageProperties(imgData);
    const imgWidth = pageWidth;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
  
    let heightLeft = imgHeight;
    let position = 0;
  
    // First page
    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  
    // Additional pages
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
  
    const fileName = `resume-${formData.fullName
      .toLowerCase()
      .replace(/\s+/g, "-")}.pdf`;
    pdf.save(fileName);
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <Header />
      </div>
      <div className="row">
        <div className="col-md-2 h-100 px-0">
          <Sidebar />
        </div>
        <div className="col-md-10 content-scroll content-bg mt-5 px-5">
        <div className="container my-4">
          <div className="row gy-4">
            <div className="col-lg-6 border border-2 rounded-4 p-4 bg-white">
              <div className="d-flex justify-content-center align-items-center mb-4">
                <div
                  className={`step-indicator text-center mx-2`}
                  onClick={() => setStep(1)}
                >
                  <div className={`circle ${step === 1 ? "step-active" : ""}`}>
                    <FaUser />
                  </div>
                  <div className="step-label">Personal Info</div>
                </div>
                <div className="step-bar mx-2" />
                <div
                  className={`step-indicator text-center mx-2`}
                  onClick={() => setStep(2)}
                >
                  <div className={`circle ${step === 2 ? "step-active" : ""}`}>
                    <PiBriefcaseDuotone />
                  </div>
                  <div className="step-label">Education & Skills</div>
                </div>
                <div className="step-bar" id="roadmap-bar-2"></div>
                <div
                  className="step-indicator text-center mx-2"
                  onClick={() => setStep(3)}
                >
                  <div
                    className={`circle ${step === 3 ? "step-active" : ""}`}
                    id="roadmap-step-3"
                  >
                    <FaFileAlt />
                  </div>
                  <div className="step-label">Template</div>
                </div>
              </div>
              {step === 1 && (
                <>
                  <h4 className="section-title">Personal Information:</h4>
                  <div className="mb-3">
                    <label htmlFor="fullName" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      className="form-control"
                      value={formData.fullName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">
                      Title
                    </label>
                    <input
                      type="text"
                      id="title"
                      className="form-control"
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">
                      Phone
                    </label>
                    <input
                      type="text"
                      id="phone"
                      className="form-control"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      id="address"
                      className="form-control"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="profilePic" className="form-label">
                      Profile Picture
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => setStep(2)}
                    >
                      Next
                    </button>
                  </div>
                </>
              )}
              {step === 2 && (
                <>
                  <h4 className="section-title">Objective/Key Competencies:</h4>
                  <div className="mb-3">
                    <label htmlFor="objective" className="form-label">
                      Objective:*
                    </label>
                    <textarea
                      id="summary"
                      className="form-control"
                      value={formData.summary}
                      rows={4}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <hr />
                  <h3 className="section-title">Education Qualification:</h3>
                  <div className="mb-3">
                    <label htmlFor="company" className="form-label">
                      Company/Organisation Name:*
                    </label>
                    <input
                      type="text"
                      id="company"
                      className="form-control"
                      value={formData.company}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="position" className="form-label">
                      Position:*
                    </label>
                    <input
                      type="text"
                      id="position"
                      className="form-control"
                      value={formData.position}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="duration" className="form-label">
                      Duration:*
                    </label>
                    <input
                      type="text"
                      id="duration"
                      className="form-control"
                      value={formData.duration}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="jobDescription" className="form-label">
                      Job Description:*
                    </label>
                    <textarea
                      id="jobDescription"
                      className="form-control"
                      rows={4}
                      value={formData.jobDescription}
                      onChange={handleChange}
                    />
                  </div>
                  <hr />
                  <h3 className="section-title">Experience:</h3>
                  <div className="mb-3">
                    <label htmlFor="ugDegree" className="form-label">
                      UG Degree:
                    </label>
                    <input
                      type="text"
                      id="ugDegree"
                      className="form-control"
                      value={formData.ugDegree}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="ugCGPA" className="form-label">
                      UG CGPA:
                    </label>
                    <input
                      type="text"
                      id="ugCGPA"
                      className="form-control"
                      value={formData.ugCGPA}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="ugYear" className="form-label">
                      UG Year:
                    </label>
                    <input
                      type="text"
                      id="ugYear"
                      className="form-control"
                      value={formData.ugYear}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="twelveBoard" className="form-label">
                      12th Board:
                    </label>
                    <input
                      type="text"
                      id="twelveBoard"
                      className="form-control"
                      value={formData.twelveBoard}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="twelvePercent" className="form-label">
                      12th Percentage:
                    </label>
                    <input
                      type="text"
                      id="twelvePercent"
                      className="form-control"
                      value={formData.twelvePercent}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="twelveYear" className="form-label">
                      12th Year:
                    </label>
                    <input
                      type="text"
                      id="twelveYear"
                      className="form-control"
                      value={formData.twelveYear}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="tenBoard" className="form-label">
                      10th Board:
                    </label>
                    <input
                      type="text"
                      id="tenBoard"
                      className="form-control"
                      value={formData.tenBoard}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="twelveBoard" className="form-label">
                      12th Board:
                    </label>
                    <input
                      type="text"
                      id="twelveBoard"
                      className="form-control"
                      value={formData.twelveBoard}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="tenPercent" className="form-label">
                      10th Percentage:
                    </label>
                    <input
                      type="text"
                      id="tenPercent"
                      className="form-control"
                      value={formData.tenPercent}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="tenYear" className="form-label">
                      10th Year:
                    </label>
                    <input
                      type="text"
                      id="tenYear"
                      className="form-control"
                      value={formData.tenYear}
                      onChange={handleChange}
                    />
                  </div>
                  <hr />
                  <h3 className="section-title">Skills:</h3>
                  <div className="mb-3">
                    <label htmlFor="skills" className="form-label">
                      Skills (one per line):*
                    </label>
                    <textarea
                      id="skills"
                      className="form-control"
                      rows={4}
                      value={formData.skills}
                      onChange={handleChange}
                    />
                  </div>
                  <h3 className="section-title">Languages:</h3>
                  <div className="mb-3">
                    <label htmlFor="languages" className="form-label">
                      Languages (one per line, e.g. Hindi:native,
                      English:proficient):
                    </label>
                    <textarea
                      id="languages"
                      className="form-control"
                      rows={4}
                      value={formData.languages}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="text-end mt-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => setStep(1)}
                    >
                      Previous
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="btn btn-secondary me-3"
                      onClick={() => setStep(3)}
                    >
                      Next
                    </button>
                  </div>
                </>
              )}
              {step === 3 && (
                <>
                  <h4 className="section-title">Templates:</h4>
                  <br />
                  <div className="d-flex gap-3">
                    <div
                      className={`color-box ${
                        formData.templateColor === "blue" ? "selected" : ""
                      }`}
                      style={{
                        backgroundColor: "#007bff",
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFormData({ ...formData, templateColor: "blue" })
                      }
                    ></div>
                    <div
                      className={`color-box ${
                        formData.templateColor === "brown" ? "selected" : ""
                      }`}
                      style={{
                        backgroundColor: "#8B4513",
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFormData({ ...formData, templateColor: "brown" })
                      }
                    ></div>
                    <div
                      className={`color-box ${
                        formData.templateColor === "orange" ? "selected" : ""
                      }`}
                      style={{
                        backgroundColor: "#FFA500",
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFormData({ ...formData, templateColor: "orange" })
                      }
                    ></div>
                  </div>
                  <br />
                  <br />

                  <label className="d-flex align-items-start gap-2">
                    <input type="checkbox" />
                    <p className="mb-0">
                      I hereby declare that all of the above information is true
                      to my knowledge.
                    </p>
                  </label>

                  <div className="text-end mt-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => setStep(2)}
                    >
                      Previous
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="btn btn-secondary me-3"
                      onClick={handleSavePDF}
                    >
                      Finish
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="col-lg-6">
              <div className="resume-preview border border-2 rounded-4 p-4 bg-white position-relative">
                <div className="text-end">
                  <button
                    className="ps-2 pe-2 pt-2 pb-2"
                    style={{
                      backgroundColor: formData.templateColor,
                      color: "white",
                      border: "none",
                    }}
                    onClick={handleSavePDF}
                  >
                    <FaFilePdf /> &nbsp; Save PDF
                  </button>
                </div>
                <div className="bg-white p-4" id="resumeContent">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <h3 className="mb-0">{formData.fullName}</h3>
                      <p className="text-secondary mb-1">{formData.title}</p>
                      <div className="mb-1">
                        <FaLocationDot
                          style={{ color: formData.templateColor }}
                        />{" "}
                        <span>{formData.address}</span>
                      </div>
                      <div className="mb-1">
                        <MdEmail style={{ color: formData.templateColor }} />{" "}
                        <span>{formData.email}</span>
                      </div>
                      <div>
                        <span>
                          <FaPhone style={{ color: formData.templateColor }} />{" "}
                          {formData.phone}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-center ms-3">
                      <div className="profile-pic-circle-lg mb-2">
                        {formData.profilePic && (
                          <img
                            src={formData.profilePic}
                            alt="Profile"
                            className="rounded-circle"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <hr className="my-3" />
                  <h4
                    className="mt-4 section-heading"
                    style={{ color: getTemplateColor() }}
                  >
                    SUMMARY
                  </h4>

                  <hr />
                  <p>{formData.summary}</p>
                  <h4
                    className="mt-4 section-heading"
                    style={{ color: getTemplateColor() }}
                  >
                    EXPERIENCE
                  </h4>
                  <hr />
                  <div className="d-flex justify-content-between">
                    <p className="mb-1 fw-semibold">{formData.company}</p>
                    <p className="mb-1 text-muted">{formData.duration}</p>
                  </div>

                  <ul>
                    {formData.jobDescription.map((exp, idx) => (
                      <li key={idx}>{exp}</li>
                    ))}
                  </ul>

                  <h4
                    className="mt-4 section-heading"
                    style={{ color: getTemplateColor() }}
                  >
                    EDUCATION
                  </h4>
                  <hr />
                  <p>
                    {" "}
                    UG: {formData.ugDegree}, {formData.ugCGPA},{" "}
                    {formData.ugYear}
                  </p>
                  <p>
                    12th: {formData.twelveBoard}, {formData.twelvePercent},{" "}
                    {formData.twelveYear}
                  </p>
                  <p>
                    10th: {formData.tenBoard}, {formData.tenPercent},{" "}
                    {formData.tenPercent}
                  </p>
                  <h4
                    className="mt-4 section-heading"
                    style={{ color: getTemplateColor() }}
                  >
                    SKILLS
                  </h4>
                  <hr />
                  <div className="d-flex flex-wrap gap-2">
                    {formData?.skills?.map((skill, idx) => (
                      <span key={idx} className="badge bg-primary">
                        {skill}
                      </span>
                    ))}
                  </div>
                  <h4
                    className="mt-4 section-heading"
                    style={{ color: getTemplateColor() }}
                  >
                    Languages:
                  </h4>
                  <hr />
                  <div className="">
                    {formData.languages.map((langItem, idx) => {
                      const [lang, level] = langItem.trim().split(":");
                      return (
                        <span key={idx} className="d-block mb-1">
                          <strong>{lang}</strong>: {level}
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeBuilder;
